//  export const SERVER_URL = "http://localhost:7000/api/v1/beegulf";
export const SERVER_URL = "https://umutuzohealthcare-backend.vercel.app/api/v1/store";
